// ============================================================
// Hit marker — brief X flash at screen center on landing a hit
// ============================================================

const DISPLAY_DURATION = 0.15; // seconds

export class HitMarker {
  private readonly el: HTMLElement;
  private timer = 0;

  constructor() {
    this.el = document.createElement('div');
    this.el.style.cssText = `
      position: absolute;
      top: 50%; left: 50%;
      transform: translate(-50%, -50%);
      width: 24px; height: 24px;
      pointer-events: none;
      z-index: 30;
      display: none;
    `;

    // Four lines forming an X
    const lineStyle = `position:absolute;background:#fff;border-radius:1px;`;
    const lines = [
      `${lineStyle}width:2px;height:12px;top:0;left:11px;transform:rotate(45deg);`,
      `${lineStyle}width:2px;height:12px;top:0;left:11px;transform:rotate(-45deg);`,
      `${lineStyle}width:2px;height:12px;bottom:0;left:11px;transform:rotate(45deg);`,
      `${lineStyle}width:2px;height:12px;bottom:0;left:11px;transform:rotate(-45deg);`,
    ];
    for (const s of lines) {
      const line = document.createElement('div');
      line.style.cssText = s;
      this.el.appendChild(line);
    }

    document.getElementById('hud')?.appendChild(this.el);
  }

  show(): void {
    this.timer = DISPLAY_DURATION;
    this.el.style.display = 'block';
  }

  update(dt: number): void {
    if (this.timer <= 0) return;
    this.timer -= dt;
    if (this.timer <= 0) {
      this.el.style.display = 'none';
    }
  }
}
